// Centralized constants for the app.
export const MAX_PNG_BYTES = 50 * 1024 * 1024; // 50 MB

// Supported ICO output sizes (width = height).
export const ICO_SIZES = [16, 32, 48, 256];

// File status enum used by App.vue's file list.
export const FILE_STATUS = {
  PENDING: 'pending',
  CONVERTING: 'converting',
  DONE: 'done',
  ERROR: 'error',
};
